import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Ensure react-router is used
import { useCookies } from 'react-cookie';
import "./App.css";
import 'react-notifications-component/dist/theme.css';
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import AuthContext from './Context/AuthContext';
import NavContext from './Context/NavContext';
import { ReactNotifications } from 'react-notifications-component';
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-SR76MX2710"; // Replace with your GA4 Measurement ID

function App() {
  const [cookies] = useCookies(["user"]);
  const [isLoggedIn, setIsLoggedIn] = useState(cookies.JWTcookie !== undefined);
  const [sidebar, setSidebar] = useState();
  const location = useLocation();

  // Initialize Google Analytics
  useEffect(() => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }, []);

  // Track page views on route change
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <div className="App">
      <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
        <ReactNotifications />
        {isLoggedIn ? (
          <NavContext.Provider value={{ sidebar, setSidebar }}>
            <Dashboard />
          </NavContext.Provider>
        ) : (
          <Login />
        )}
      </AuthContext.Provider>
    </div>
  );
}

export default App;
